export default __webpack_public_path__ + "static/media/LF_Logo_V2_5.9b3dfab4.png";